import values from 'lodash/values'
import { createSelector } from 'reselect'

const _users = state => state.users.users

export const createdUser = state => state.users.create.createdUser
export const errors = state => state.users.errors
export const pendings = state => state.users.pendings
export const sortBy = state => state.users.sortBy
export const sortOrder = state => state.users.sortOrder

/**
 * Iterates over all rugs and filters out all rugs
 * which isn't advised by the advisor.
 * @returns {array} Filtered Rugs
 */
export const sortedUsers = createSelector(
  [_users, sortBy, sortOrder],
  (users, sortBy, sortOrder) => {
    return values(users).sort((a, b) => {
      switch (sortBy) {
        case 'email':
          if (sortOrder === 'ascending') {
            return a.email.localeCompare(b.email)
          } else {
            return b.email.localeCompare(a.email)
          }

        case 'firstName':
          if (sortOrder === 'ascending') {
            return a.firstName.localeCompare(b.firstName)
          } else {
            return b.firstName.localeCompare(a.firstName)
          }

        case 'lastName':
          if (sortOrder === 'ascending') {
            return a.lastName.localeCompare(b.lastName)
          } else {
            return b.lastName.localeCompare(a.lastName)
          }

        case 'lastLogin':
          if (sortOrder === 'ascending') {
            return new Date(a.lastLogin) - new Date(b.lastLogin)
          } else {
            return new Date(b.lastLogin) - new Date(a.lastLogin)
          }

        default:
          return a.id - b.id
      }
    })
  },
)
